var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "00-Elements-/-Icons-/-search-icon",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.99999995,0.999999955 C13.4183,0.999999955 17,4.58171997 17,8.99999995 C17,10.8380319 16.3801522,12.5312969 15.3380953,13.8821563 L16.7025093,15.2467819 C16.8279829,15.3429228 16.9476911,15.4476911 17.0607,15.5607 L18.7273,17.2273 C18.7855,17.2855 18.8352,17.3506111 18.8756,17.4207074 L19.2426406,17.7870057 C19.6722174,18.2165824 19.6722174,18.9130639 19.2426406,19.3426406 C18.8130639,19.7722174 18.1165824,19.7722174 17.6870057,19.3426406 L13.7680646,15.4244958 C12.4365104,16.4143245 10.7866481,17 8.99999995,17 C4.58171997,17 0.999999955,13.4183 0.999999955,8.99999995 C0.999999955,4.58171997 4.58171997,0.999999955 8.99999995,0.999999955 Z M8.99999996,2.99999996 C5.68628998,2.99999996 2.99999996,5.68628998 2.99999996,8.99999996 C2.99999996,12.3137 5.68628998,15 8.99999996,15 C12.3137,15 15,12.3137 15,8.99999996 C15,5.68628998 12.3137,2.99999996 8.99999996,2.99999996 Z",
  id: "Combined-Shape"
}));

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.13552a4b.svg";
export { ForwardRef as ReactComponent };